import { render } from "./Dustbin.vue?vue&type=template&id=1bc5896b&scoped=true"
import script from "./Dustbin.vue?vue&type=script&lang=js"
export * from "./Dustbin.vue?vue&type=script&lang=js"

import "./Dustbin.vue?vue&type=style&index=0&id=1bc5896b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc5896b"]])

export default __exports__